(function() {
'use strict';

angular
    .module('transfers')
    .controller('TransferDirection', TransferDirection);

function TransferDirection($scope, searchUnitService, $location, $route, resourceService) {
    const cm = this;

    cm.directions = [
        { val: 1, name: resourceService.get('RETURN') },
        { val: 2, name: resourceService.get('AIRPORTTORESORT') },
        { val: 3, name: resourceService.get('RESORTTOAIRPORT') }
    ];

    cm.transfer = {
        direction: searchUnitService.getDirection()
    };

    $scope.$on('radio-clicked', function() {
        searchUnitService.setDirection(cm.transfer.direction);
        $location.path($route.current.area);
    });
}
})();
